import { EbookingRequestTugDTO } from "src/app/front-user/services/e-booking/shared/models/ebooking-request-tug.model";

export class FeesEstimationAdminDto {
    RequestId: string;
    AdminEmail: string;
    MoreInformation: string;
    Decision: number;
    InsuranceValue: number;
    FeeValue: number;
    MarineRequirements: string;
    TotlFees: number;
    MeasurementDescription: string;
    ShipSituation?: number;
    AdminSCNT: number;
    AdminSCGT: number;
    EbookingRequestTugs: EbookingRequestTugDTO[];
}